module.exports = __webpack_public_path__ + "static/media/me.f3134158.jpg";